import { ICommand } from 'core-ts-types';
import { STCSchedulingConfigModel } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { IOrganizer } from '../types/appt_interfaces';
import { TAlternateAppointmentTimesUsersource } from '../usersources/alternate_appointment_times_usersource';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

export interface IAppointmentsCommand {
  url: string;
  method: string;
  data?: object;
  params?: object;
  headers?: object;
}
export enum AppointmentsApiVersion {
  V1,
  V2,
  V3
}
export interface ISelectedAppointmentTypeValues {
  appointment_type_id: number;
  student_service_id?: number;
  course_id?: number;
}

export interface IAlternateAppointmentConfirmCommandParams {
  appointment_type_id: number;
  location_id: number;
  comment: string;
  student_service_id?: number;
  course_id?: number;
}

export class AppointmentsCommandServant {
  constructor(
    private $http: any,
    private $q: any,
    private authToken: any,
    private accountModel: any,
    private appConfigModel: any,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private log: any,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAlternateAppointmentTimesUsersource: TAlternateAppointmentTimesUsersource,
    private loadStcScheduleConfigCommand: ICommand,
    private ngStcSchedulingConfigModel: STCSchedulingConfigModel
  ) {}

  public request(obj: IAppointmentsCommand): any {
    obj.url = `/api/v2/scheduling/${obj.url}`;
    return this.authToken.campusTokenRequest(obj);
  }

  public get locationsCommandParams() {
    return this._selectedAppointmentTypeValues();
  }

  public get alternateAppointmentConfirmCommandParams(): IAlternateAppointmentConfirmCommandParams {
    const selectedAppointmentTypeValues = this._selectedAppointmentTypeValues();
    return {
      location_id: this.ngAlternateAppointmentTimesUsersource.read().selectedLocation.id,
      comment: this.ngAlternateAppointmentTimesUsersource.availability,
      ...selectedAppointmentTypeValues
    };
  }

  public get walkIntimesCommandParams(): any {
    const location_ids = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.id.toString();
    const student_service_id = _4.get(this.ngAppointmentReasonUsersource.read(), 'selectedService.id');
    const organizer_ids = this.selectedOrganizerIds();
    const course_id = this.getCourseId();
    const care_unit_id = _4.get(this.ngAppointmentReasonUsersource.read(), 'selectedType.id');
    if (!_4.isUndefined(course_id)) {
      return {
        location_ids,
        organizer_ids,
        course_id,
        student_service_id,
        care_unit_id
      };
    }
    return {
      location_ids,
      organizer_ids,
      student_service_id
    };
  }

  public getCourseId() {
    return this.ngAppointmentReasonUsersource.read().selectedService.isCourse
      ? this.ngAppointmentReasonUsersource.read().selectedService.id
      : _4.get(this.ngAppointmentLocationsOrganizersUsersource.read(), 'selectedCourse.id', undefined);
  }

  public getCourseOrServiceID(): ISelectedAppointmentTypeValues {
    const data: ISelectedAppointmentTypeValues = {} as any;
    const course_id = this.getCourseId();
    const selected_service_id = this.ngAppointmentReasonUsersource.read().selectedService.id;
    if (this.ngAppointmentReasonUsersource.read().selectedService.isCourse) {
      data.course_id = selected_service_id;
    } else {
      data.student_service_id = selected_service_id;
    }
    if (course_id) {
      data.course_id = course_id;
    }
    return data;
  }

  private _selectedAppointmentTypeValues() {
    const params = {} as ISelectedAppointmentTypeValues;
    const selectedServiceId = this.ngAppointmentReasonUsersource.read().selectedService.id;
    params.appointment_type_id = this.ngAppointmentReasonUsersource.read().selectedType.id;
    params.course_id = this.getCourseId();
    if (!this.ngAppointmentReasonUsersource.read().selectedService.isCourse) {
      params.student_service_id = selectedServiceId;
    }
    return params;
  }

  public selectedOrganizerIds(): string {
    const selectedOrganizers = this.ngAppointmentLocationsOrganizersUsersource.read().selectedOrganizers;
    const selectedLocation = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation;
    const selectedCourse = this.ngAppointmentLocationsOrganizersUsersource.read().selectedCourse;
    let selectedOrganizerIds: string = '';
    if (_4.size(selectedOrganizers)) {
      selectedOrganizerIds = _4.join(
        _4.map(selectedOrganizers, (organizer: IOrganizer) => organizer.id),
        ','
      );
    } else if (!_4.isNil(selectedCourse) && !_4.isEmpty(selectedCourse)) {
      selectedOrganizerIds = _4.join(
        _4.map(selectedCourse.organizers, (organizer: IOrganizer) => organizer.id),
        ','
      );
    } else {
      selectedOrganizerIds = _4.join(
        _4.map(selectedLocation.organizers as IOrganizer[], (organizer: IOrganizer) => organizer.id),
        ','
      );
    }
    return selectedOrganizerIds;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointments_command_servant.ts